import { Icon } from './Icon';

interface ReqRowProps {
  met?: boolean;
  pending?: boolean;
  label: string;
  th: string;
  detail?: string | null;
}

/** A single certificate-requirement row (met / pending / unmet). */
export function ReqRow({ met, pending, label, th, detail }: ReqRowProps) {
  const tone = met ? 'sage' : pending ? 'ochre' : 'ink-4';
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        padding: '13px 0',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
        <span
          style={{
            width: 24,
            height: 24,
            borderRadius: '50%',
            flex: 'none',
            display: 'grid',
            placeItems: 'center',
            background: met ? 'var(--sage)' : pending ? 'var(--ochre-soft)' : 'var(--paper-2)',
            color: met ? 'var(--on-accent)' : pending ? '#856024' : 'var(--ink-4)',
          }}
        >
          {met ? (
            <Icon name="check" size={14} stroke={2.6} />
          ) : pending ? (
            <Icon name="clock" size={13} />
          ) : (
            <Icon name="lock" size={12} />
          )}
        </span>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 14.5, fontWeight: 500 }}>{label}</div>
          <div className="th" style={{ fontSize: 12, color: 'var(--ink-3)' }}>
            {th}
          </div>
        </div>
      </div>
      {detail && (
        <span
          className="u-mono"
          style={{ fontSize: 12.5, color: `var(--${tone})`, flex: 'none', fontWeight: 500 }}
        >
          {detail}
        </span>
      )}
    </div>
  );
}
